import { Route, Switch } from "react-router-dom";

import PrivateRoutes from "./PrivateRoutes";

import { Login } from "../pages/login/Login";
import { Home } from "../pages/home/Home";

// AdmUsuario
import {
  AcessoSistemas,
  CadastroUsuario,
  ListaUsuario,
  TipoAcesso,
} from "../pages/gerenciamento-usuario";

// Consultas Integradas
// Consulta Civil
import {
  FiltroCivilCPF,
  FiltroCivilRG,
  FiltroCivilNominal,
  FichaCivil,
} from "../pages/consultas/consulta-civil";
import { ConsultasIntegradas } from "../pages/consultas/consultas-integradas/ConsultasIntegradas";

// Consulta Criminal
import {
  FiltroCriminalNominal,
  FiltroCriminalCPF,
  FiltroCriminalRC,
  FichaCriminal,
} from "../pages/consultas/consulta-criminal";

// Consulta Carcerario
import {
  FiltroCarcerarioNominal,
  FiltroCarcerarioRG,
  FichaCarceraria,
} from "../pages/consultas/consulta-carcerario";

// Consulta Mandado
import {
  FiltroMandadoNominal,
  FichaMandado,
} from "../pages/consultas/consulta-mandado";

// Consulta celular
import {
  ConsultaCelular,
  ConsultaCelularNome,
  FichaCelular,
} from "../pages/consultas/consulta-celular";

// Consulta Bike
import { ConsultaBike, FichaBike } from "../pages/consultas/consulta-bike";

// Consulta Veiculo
import {
  ConsultaVeiculoPlaca,
  ConsultaVeiculoChassi,
  FichaVeiculo,
} from "../pages/consultas/consulta-veiculo";

// BOEPM
import {
  BoDaOmeData,
  BoDaOmeOcorrencia,
  BoPorOmeData,
  BoPorOmeOcorrencia,
  BoPorUsuarioData,
  BoPorUsuarioOcorrencia,
} from "../pages/boepm";
import { FiltroMandadoFacial } from "../pages/consultas/consulta-mandado/mandado-facial";
// import { TestConsultaCelular } from "../pages/test";
// import { TestRecon } from "../pages/test/Test-Recon";
// import { TestReconCapture } from "../pages/test/Test-Recon-Capture";

function Routes() {
  return (
    <Switch>
      {/* <Route path="/test-consulta-celular" component={TestConsultaCelular} /> */}
      {/* <Route path="/test-recon" component={TestRecon} /> */}
      {/* <Route path="/test-recon-cap" component={TestReconCapture} /> */}
      <PrivateRoutes
        path="/"
        exact
        component={Login}
        isPrivate={false}
        // signed={signed}
      />

      {/* Rotas Autenticadas */}
      <PrivateRoutes
        path="/pagina-inicial"
        exact
        component={Home}
        isPrivate
        // signed={signed}
      />

      {/* Rotas Autenticadas */}

      {/* Rotas adm usuario */}
      <PrivateRoutes
        path="/gerenciamentodeusuario/cadastro-usuario"
        exact
        component={CadastroUsuario}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/gerenciamentodeusuario/tipo-acesso/:CPF"
        exact
        component={TipoAcesso}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/gerenciamentodeusuario/acesso-a-sistema/:CPF"
        exact
        component={AcessoSistemas}
        isPrivate
        // signed={signed}
      />
      <PrivateRoutes
        path="/gerenciamentodeusuario/lista-usuario"
        exact
        component={ListaUsuario}
        isPrivate
        // signed={signed}
      />

      {/* Rotas Consultas Integradas */}
      {/* Rotas Consultas Civil */}

      <PrivateRoutes
        path="/consultas-integradas"
        exact
        component={ConsultasIntegradas}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/consulta-civil-pesquisa-por-rg"
        exact
        component={FiltroCivilRG}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/consulta-civil-pesquisa-por-cpf"
        exact
        component={FiltroCivilCPF}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/consulta-civil-pesquisa-nominal"
        exact
        component={FiltroCivilNominal}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/consulta-civil/ficha-civil/:NumeroPessoa+"
        exact
        component={FichaCivil}
        isPrivate
        // signed={signed}
      />

      {/* Rotas Consultas criminal */}
      <PrivateRoutes
        path="/consulta-criminal-pesquisa-por-cpf"
        exact
        component={FiltroCriminalCPF}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/consulta-criminal-pesquisa-por-rc"
        exact
        component={FiltroCriminalRC}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/consulta-criminal-pesquisa-nominal"
        exact
        component={FiltroCriminalNominal}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/consulta-criminal/ficha-criminal/:NumeroPessoa+"
        exact
        component={FichaCriminal}
        isPrivate
        // signed={signed}
      />

      {/* Rotas Consultas Carcerario */}
      <PrivateRoutes
        path="/consulta-carcerario-por-rg"
        exact
        component={FiltroCarcerarioRG}
        isPrivate
        // signed={signed}
      />
      <PrivateRoutes
        path="/consulta-carcerario-nominal"
        exact
        component={FiltroCarcerarioNominal}
        isPrivate
        // signed={signed}
      />
      <PrivateRoutes
        path="/consulta-carcerario/ficha-carcerario/:DET_ID"
        exact
        component={FichaCarceraria}
        isPrivate
        // signed={signed}
      />

      {/* Rotas Consultas mandado */}
      {/* <PrivateRoutes
        path="/consulta-mandado-pesquisa-nominal"
        exact
        component={FiltroMandadoNominal}
        isPrivate
        // signed={signed}
      /> */}
      <PrivateRoutes
        path="/consulta-mandado-facial"
        exact
        component={FiltroMandadoFacial}
        isPrivate
        // signed={signed}
      />
      <PrivateRoutes
        path="/consulta-mandado/ficha-mandado/:CADASTRO"
        exact
        component={FichaMandado}
        isPrivate
        // signed={signed}
      />

      {/* Rotas Consultas celular */}
      <PrivateRoutes
        path="/alerta/consulta-celular"
        exact
        component={ConsultaCelular}
        isPrivate
        // signed={signed}
      />
      <PrivateRoutes
        path="/alerta/consulta-celular-nome"
        exact
        component={ConsultaCelularNome}
        isPrivate
        // signed={signed}
      />
      <PrivateRoutes
        path="/alerta/consulta-celular/ficha-celular"
        exact
        component={FichaCelular}
        isPrivate
        // signed={signed}
      />
      {/* Rotas Consultas Bike */}
      <PrivateRoutes
        path="/alerta/consulta-bike"
        exact
        component={ConsultaBike}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/alerta/consulta-bike/ficha-bike/:CHASSI/:MARCA/:ID_BIKE"
        exact
        component={FichaBike}
        isPrivate
        // signed={signed}
      />

      {/* Rotas Consultas Veiculos */}
      <PrivateRoutes
        path="/consulta-veiculo/consulta-placa"
        exact
        component={ConsultaVeiculoPlaca}
        isPrivate
        // signed={signed}
      />
      <PrivateRoutes
        path="/consulta-veiculo/consulta-chassi"
        exact
        component={ConsultaVeiculoChassi}
        isPrivate
        // signed={signed}
      />

      <PrivateRoutes
        path="/consulta-veiculo/ficha-veiculo"
        exact
        component={FichaVeiculo}
        isPrivate
        // signed={signed}
      />
      {/* Rotas BOEPM */}

      <PrivateRoutes
        path="/boepm/bos-do-usuario-ocorrencia"
        exact
        component={BoPorUsuarioOcorrencia}
        isPrivate
      />

      <PrivateRoutes
        path="/boepm/bos-do-usuario-data"
        exact
        component={BoPorUsuarioData}
        isPrivate
      />

      <PrivateRoutes
        path="/boepm/bos-da-ome-ocorrencia"
        exact
        component={BoDaOmeOcorrencia}
        isPrivate
      />

      <PrivateRoutes
        path="/boepm/bos-da-ome-data"
        exact
        component={BoDaOmeData}
        isPrivate
      />

      <PrivateRoutes
        path="/boepm/bos-por-ome-data"
        exact
        component={BoPorOmeData}
        isPrivate
      />
      <PrivateRoutes
        path="/boepm/bos-por-ome-ocorrencia"
        exact
        component={BoPorOmeOcorrencia}
        isPrivate
      />
    </Switch>
  );
}

export default Routes;
